import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Skeleton } from "@/components/ui/skeleton";
import { useUsers } from "@/contexts/users-provider";
import { useTranslation } from "@/hooks/useTranslation";
import { TeamApiKeyDTO } from "@shaarp/common";
import { useEffect } from "react";

export default function DataTableCellTeamApiKeyCreatedBy({
  apiKey,
}: {
  apiKey: TeamApiKeyDTO;
}) {
  const { users, apiFetchUsers, apiFetchLoading } = useUsers();
  const { t } = useTranslation();

  useEffect(() => {
    const init = async () => {
      await apiFetchUsers();
    };
    init();
  }, []);

  // Show skeleton while loading
  if (apiFetchLoading) {
    return (
      <div className="flex items-center">
        <Skeleton className="w-8 h-8 rounded-full" />
        <Skeleton className="ml-2 h-4 w-24" />
      </div>
    );
  }

  // Find the user in the team users list
  const user = users.find((u) => u.id === apiKey.createdBy);

  if (!user) {
    return (
      <div className="flex items-center">
        <Avatar className="w-8 h-8">
          <AvatarFallback className="text-xs">
            {apiKey.createdBy.slice(0, 2).toUpperCase()}
          </AvatarFallback>
        </Avatar>
        <span className="ml-2 text-muted-foreground text-sm">
          {t("team.apiKeys.dataTable.unknownUser")}
        </span>
      </div>
    );
  }

  return (
    <div className="flex items-center">
      <Avatar className="w-8 h-8">
        <AvatarImage src={user.imageUrl} alt={user.fullName} />
        <AvatarFallback className="text-xs">
          {user.fullName
            .split(" ")
            .map((n) => n[0])
            .join("")
            .toUpperCase()
            .slice(0, 2)}
        </AvatarFallback>
      </Avatar>
      <span className="ml-2 text-sm">{user.fullName}</span>
    </div>
  );
}
